<div class="main">
    <div class="container">
      <div class="header">
        <img
          src="../../../../../assets/images/logos/NanoH2O-Black@3x 1.png"
          alt="LG NanoH2O - Login"
          class="center"
          height="40"
          width="380"
        />
  
        <!-- <label class="" style="margin-top: 25px; font-size: larger; color:rgb(107,107,107);">Forgot Password</label> -->
      </div>
      <div style="background-color: rgb(255, 103, 39); height: 10px"></div>
      <form
        [formGroup]="ForgetUsernameForm"
        role="form"
        name="form"
        (ngSubmit)="onSubmit()"
      >
        <label
          style="
            padding-top: 15px;
            padding-bottom: 10px;
            font-size: medium;
            font-weight: bold;
          "
        >
          Enter email address to recover username(s) 
        </label>
        <input
          type="text"
          id="EmailAddress"
          name="EmailAddress"
          placeholder="EmailAddress"
          formControlName="EmailAddress"
          (change)="validateUsername()"
          
        />
        <div
          *ngIf="submitted && ForgetUsernameForm.controls.EmailAddress.errors"
          class="text-danger"
          style="text-align: left"
        >
          <span *ngIf="ForgetUsernameForm.controls.EmailAddress.errors.required"
            >Email Id is required.</span
          >
        </div>
  
        <button type="submit">SUBMIT</button>
        <br>
        
      </form>
    </div>
  </div>
  